import { useUser, useClerk } from "@clerk/clerk-react";

const S = {
  page: {
    minHeight: "100vh", background: "#0a0a0f", display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center", padding: "40px 24px",
    fontFamily: "'DM Serif Display', Georgia, serif", color: "#e8e4dc",
    backgroundImage: "radial-gradient(ellipse 80% 50% at 50% -10%, rgba(99,102,241,0.15) 0%, transparent 70%)"
  },
  card: { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 20, padding: "48px 40px", width: "100%", maxWidth: 480, textAlign: "center" },
  logo: { fontSize: 32, fontStyle: "italic", marginBottom: 8 },
  sub: { fontFamily: "'DM Mono', monospace", fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: "rgba(232,228,220,0.4)", marginBottom: 40 },
  price: { fontSize: 64, fontWeight: 400, lineHeight: 1, marginBottom: 4 },
  period: { fontFamily: "'DM Mono', monospace", fontSize: 12, color: "rgba(232,228,220,0.4)", marginBottom: 40 },
  features: { textAlign: "left", marginBottom: 40 },
  feat: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14, fontFamily: "'DM Mono', monospace", fontSize: 13, color: "rgba(232,228,220,0.75)" },
  check: { width: 20, height: 20, background: "rgba(99,102,241,0.2)", border: "1px solid rgba(99,102,241,0.4)", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 10, color: "#a5b4fc" },
  btn: { width: "100%", background: "linear-gradient(135deg, #6366f1, #8b5cf6)", border: "none", borderRadius: 12, padding: "16px", color: "#fff", fontFamily: "'DM Mono', monospace", fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase", cursor: "pointer", marginBottom: 16 },
  trial: { fontFamily: "'DM Mono', monospace", fontSize: 11, color: "rgba(232,228,220,0.3)", marginBottom: 24 },
  signout: { background: "none", border: "none", cursor: "pointer", fontFamily: "'DM Mono', monospace", fontSize: 10, color: "rgba(232,228,220,0.25)", letterSpacing: "0.1em", textTransform: "uppercase" }
};

const FEATURES = [
  "Income goal tracker with visual progress",
  "Client profitability ranking & scoring",
  "Real-time tax estimate counter",
  "Cash flow runway calculator",
  "AI-powered financial insights",
  "Unlimited clients & expenses"
];

export default function Paywall({ onSubscribed }) {
  const { user } = useUser();
  const { signOut } = useClerk();

  const handleSubscribe = () => {
    window.location.href = "https://buy.stripe.com/6oU9AV4EWgkkgmE3O5fAc01";
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.logo}>Zeno Finance</div>
        <div style={S.sub}>Start your free trial</div>
        <div style={S.price}>$12</div>
        <div style={S.period}>per month · cancel anytime</div>
        <div style={S.features}>
          {FEATURES.map(f => (
            <div key={f} style={S.feat}>
              <div style={S.check}>✓</div>
              {f}
            </div>
          ))}
        </div>
        <button style={S.btn} onClick={handleSubscribe}>Start 7-Day Free Trial →</button>
        <div style={S.trial}>No charge for 7 days. Then $12/month.</div>
        <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: "rgba(232,228,220,0.3)", marginBottom: 16 }}>
          Signed in as {user?.emailAddresses?.[0]?.emailAddress}
        </div>
        <button style={S.signout} onClick={() => signOut()}>Sign out</button>
      </div>
    </div>
  );
}
